'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsBotInAwayMode = undefined;

var _reselect = require('reselect');

var _getAssignedResponderInWidget = require('../../responders/selectors/getAssignedResponderInWidget');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _getIsWidgetInAwayMode = require('./getIsWidgetInAwayMode');

var getIsBotInAwayMode = exports.getIsBotInAwayMode = (0, _reselect.createSelector)([_getIsWidgetInAwayMode.getIsWidgetInAwayMode, _getAssignedResponderInWidget.getAssignedResponderInWidget], function (isWidgetInAwayMode, assignedResponder) {
  return Boolean(isWidgetInAwayMode && assignedResponder && (0, _responderGetters.getIsBot)(assignedResponder));
});